/* Polsk katalog for locale-reports-labels-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'rep.zeroHidden': 'Konta mają saldo zerowe w tym okresie. Pokaż je za pomocą filtrów.',
  'rep.showZero': 'Pokaż konta z saldem zerowym',
  'rep.group.tax': 'PODATEK DOCHODOWY',
  'rep.trial.titleHelp': 'Zestawienie obrotów i sald zawiera wszystkie konta z planu kont z saldem za wybrany okres. Dotknij wiersza konta, aby zobaczyć dokumenty zaksięgowane na tym koncie.',
  'rep.trial.viewHelp': 'Domyślnie zestawienie obrotów i sald pokazuje tylko aktywne konta — konta z saldem lub obrotami. „Pokaż także nieaktywne konta” dodaje resztę planu kont, a „Pokaż tylko konta z obrotami” wymaga, aby na koncie były księgowania w danym okresie. „Pokaż jako” określa, czy kwoty są wyświetlane w koronach i øre, w pełnych koronach czy w pełnych tysiącach.',
  'rep.trial.empty': 'Brak zaksięgowanych sald za wybrany okres.',
  'rep.trial.oneSupplier': '1 dostawca',
  'rep.trial.supplierCount': 'Dostawcy: {n}',
  'rep.trial.oneCustomer': '1 klient',
  'rep.trial.customerCount': 'Klienci: {n}',
  'rep.trial.oneOpenCustomerItem': '1 otwarta pozycja',
  'rep.trial.openCustomerItems': 'Otwarte pozycje: {n}',
  'rep.trial.customerDifference': 'Inne księgowania / różnica uzgodnienia',
  'rep.trial.noCustomerBalances': 'Brak sald klientów w wybranym widoku.',
  'rep.trial.oneOpenSupplierItem': '1 otwarta pozycja',
  'rep.trial.openSupplierItems': 'Otwarte pozycje: {n}',
  'rep.trial.supplierDifference': 'Inne księgowania / różnica uzgodnienia',
  'rep.trial.noSupplierBalances': 'Brak sald dostawców w wybranym widoku.',
  'rep.trial.exportTitle': 'Zestawienie obrotów i sald: {column}',
  'rep.group.assets': 'AKTYWA',
  'rep.group.equityLiabilities': 'KAPITAŁ WŁASNY / ZOBOWIĄZANIA',
  'rep.group.operatingIncome': 'PRZYCHODY OPERACYJNE',
  'rep.group.operatingCosts': 'KOSZTY OPERACYJNE',
  'rep.groupTotal': 'Suma {group}',
  'rep.balance.opening': 'Stan początkowy',
  'rep.balance.movement': 'Zmiana',
  'rep.balance.closing': 'Stan końcowy',
  'rep.showAs.withDecimals': 'Korony i øre',
  'rep.showAs.whole': 'Pełne korony',
  'rep.showAs.thousands': 'Pełne tysiące',
  'rep.result.titleHelp': 'Rachunek zysków i strat pokazuje przychody i koszty w okresie oraz to, co pozostaje jako wynik. Otwórz sekcję, aby zobaczyć konta stojące za liczbami, i dotknij wiersza konta, aby zobaczyć zaksięgowane na nim dokumenty.',
  'rep.result.subtitle': 'Zacznij od podsumowania i w razie potrzeby otwórz szczegóły kont.',
  'rep.result.income': 'Przychody operacyjne',
  'rep.result.costs': 'Koszty operacyjne',
  'rep.result.finance': 'Działalność finansowa',
  'rep.result.beforeTax': 'Wynik przed opodatkowaniem',
  'rep.result.noLines': 'Brak jeszcze aktywności na tych kontach.',
  'rep.total': 'Suma',
  'rep.showDetails': 'Pokaż szczegóły',
  'rep.hideDetails': 'Ukryj szczegóły',
  'rep.shareOfLargest': '{pct} % największej pozycji',
  'rep.showVouchersFor': 'Pokaż wszystkie dokumenty na koncie {account}',
  'rep.period.otherYear': 'Wyświetlane są dane za rok obrotowy {year}.',
  'rep.period.singleYear': 'Okres obejmuje dwa lata obrotowe. Raporty są liczone dla każdego roku obrotowego z bilansem otwarcia od początku roku, więc wybierz okres w obrębie jednego roku.',
  'rep.export.busy': 'Eksportowanie...',
  'rep.export.downloaded': 'Pobrano {format}',
  'rep.export.failed': 'Nie udało się wyeksportować raportu.',
  'rep.export.pdfUnavailable': 'PDF raportu nie jest połączony z backendem.',
  'rep.export.year': 'Rok',
  'rep.export.period': 'Okres',
  'rep.export.summary': 'Podsumowanie',
  'rep.export.item': 'Pozycja',
  'rep.export.amount': 'Kwota',
  'rep.accountHelp.receivables': 'Należności od odbiorców to pieniądze, które klienci są Ci winni za jeszcze nieopłacone faktury.',
  'rep.accountHelp.bank': 'Środki w banku pokazują pieniądze na rachunku bieżącym firmy.',
  'rep.accountHelp.payables': 'Zobowiązania wobec dostawców to faktury i zakupy, które musisz zapłacić dostawcom.',
  'rep.accountHelp.outputVat': 'VAT należny to podatek VAT pobrany przy sprzedaży.',
  'rep.accountHelp.inputVat': 'VAT naliczony to podatek VAT zapłacony przy zakupach, który zwykle można odliczyć.',
  'rep.accountHelp.vatSettlement': 'Konto rozliczeniowe VAT pokazuje VAT netto do zapłaty lub do zwrotu.',
  'rep.accountHelp.vatableSales': 'Przychody ze sprzedaży opodatkowanej VAT pokazują zwykłą sprzedaż, od której naliczany jest VAT należny.',
  'rep.accountHelp.group.asset': 'Konto aktywów: wartości, które firma posiada lub które są jej należne.',
  'rep.accountHelp.group.equityLiability': 'Kapitał własny lub zobowiązania: finansowanie, kwoty należne i pozycje rozliczeniowe.',
  'rep.accountHelp.group.income': 'Konto przychodów: sprzedaż i inne przychody firmy.',
  'rep.accountHelp.group.goods': 'Koszt towarów: koszty związane z towarami, surowcami lub odsprzedażą.',
  'rep.accountHelp.group.payroll': 'Koszty wynagrodzeń: wynagrodzenia, dodatek urlopowy i świadczenia pracownicze.',
  'rep.accountHelp.group.operating': 'Koszt operacyjny: koszty prowadzenia działalności.',
  'rep.accountHelp.group.finance': 'Konto finansowe lub podatkowe: odsetki, pozycje finansowe lub koszt podatku.',
  'rep.accountHelp.other': 'Konto {account} w planie kont.',
  'rep.accountHelp.openVouchers': 'Dotknij wiersza konta, aby zobaczyć wszystkie dokumenty zaksięgowane na tym koncie.',
  'rep.dimensions.title': 'Projekt i dział',
  'rep.dimensions.help': 'Filtruj raport bez zmiany danych źródłowych. Cały dokument zostaje zachowany, łącznie z pozycjami przeciwstawnymi.',
  'rep.dimensions.project': 'Projekt',
  'rep.dimensions.department': 'Dział',
  'rep.dimensions.all': 'Wszystkie',
  'rep.dimensions.unassigned': 'Nieprzypisane',
  'rep.incompleteBasisTitle': 'Podstawa księgowa jest niekompletna',
  'rep.incompleteBasisText': 'Raport nie jest prezentowany jako kompletny, ponieważ pokrycie dziennika lub wymagana podstawa otwarcia nie zostały udokumentowane. Dostępne dane są zachowane do kontroli.',
  'rep.importedBasisTitle': 'Zaimportowane statystyki księgowe.',
  'rep.importedBasisText': 'Te dane pochodzą ze sprawdzonych, zaimportowanych statystyk kont, a nie z zapisów dziennika w Plumme. Nie są certyfikowane i nie mogą być używane do składania deklaracji, zatwierdzania płatności ani zamknięcia roku.',
  'rep.importedBasisExport': 'Sprawdzone, zaimportowane statystyki kont; dziennik niekompletny, brak certyfikacji.',
});
